"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.ImageTypes = void 0;
var ImageTypes;
(function (ImageTypes) {
    ImageTypes["NODE"] = "NODE";
    ImageTypes["NODE_SERVICE_ISSUE"] = "NODE_SERVICE_ISSUE";
})(ImageTypes || (exports.ImageTypes = ImageTypes = {}));
exports.path = '/service-center-image-upload';
//# sourceMappingURL=index.js.map